import * as React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// https://mui.com/material-ui/react-progress/?srsltid=AfmBOoqpUvilhODGRce0K_vG0uU5j_VjxVJIsGLgtWunV0cYjx2semCE#circular-with-label

const CircularProgressWithLabel = (props) => {
  const progressProps = { ...props }
  delete progressProps.showTrack
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {props.showTrack ? <CircularProgress {...props} variant='determinate' value={100} sx={{ position: 'absolute', top: 0, left: 0, color: (theme) => theme.palette.background.paper }} /> : null}
      <CircularProgress {...progressProps} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography
          variant='caption'
          component='div'
          sx={{ color: 'text.secondary' }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired
}

export default CircularProgressWithLabel
